export default "__VITE_ASSET__CIfxggEO__"